/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import summaryStyle from "../../../Common/Style/summaryStyle";
import GridEditRow from "../../../Common/GridEditRow/GridEditRow";
import Typography from "@mui/material/Typography";
import { AbstractCase } from "../../../../../types/Entities/AbstractCase";
import { Box } from "@mui/material";

type PersonDataProps = {
  formData: AbstractCase | Record<string, any>;
  personType: string;
  formPath: string;
  section: string;
  title: string;
};

const PersonData = ({ formData, personType, formPath, section, title }: PersonDataProps) => {
  const personData = formData[personType];
  return (
    <>
      <Grid item xs={12} sx={summaryStyle.subHeadline}>
        <Typography variant={"h5"}>{title}</Typography>
      </Grid>
      {personType === "alimonyPartner" && (
        <>
          <Grid item xs={12} sx={summaryStyle.question}>
            <Box id={personType + ".person.gender"} sx={summaryStyle.scrollToAnchor} />
            Anrede
          </Grid>
          <GridEditRow
            item
            xs={12}
            to={{
              pathname: formPath,
              state: {
                section: section,
                field: personType + ".person.gender",
              },
            }}
          >
            {personData.person.gender === "male" ? "Herr" : "Frau"}
          </GridEditRow>

          <Grid item xs={12} sx={summaryStyle.question}>
            <Box id={personType + ".person.givenName"} sx={summaryStyle.scrollToAnchor} />
            Vorname
          </Grid>
          <GridEditRow
            item
            xs={12}
            to={{
              pathname: formPath,
              state: {
                section: section,
                field: personType + ".person.givenName",
              },
            }}
          >
            {personData.person.givenName}
          </GridEditRow>

          <Grid item xs={12} sx={summaryStyle.question}>
            <Box id={personType + ".person.familyName"} sx={summaryStyle.scrollToAnchor} />
            Nachname
          </Grid>
          <GridEditRow
            item
            xs={12}
            to={{
              pathname: formPath,
              state: {
                section: section,
                field: personType + ".person.familyName",
              },
            }}
          >
            {personData.person.familyName}
          </GridEditRow>
        </>
      )}

      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={personType + ".isEmployed"} sx={summaryStyle.scrollToAnchor} />
        Erwerbstätig?
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: personType + ".isEmployed",
          },
        }}
      >
        {personData.isEmployed ? "Ja" : "Nein"}
      </GridEditRow>

      {personData.isEmployed && (
        <>
          <Grid item xs={12} sx={summaryStyle.question}>
            <Box id={personType + ".netIncome"} sx={summaryStyle.scrollToAnchor} />
            Nettoeinkommen
          </Grid>
          <GridEditRow
            item
            xs={12}
            to={{
              pathname: formPath,
              state: {
                section: section,
                field: personType + ".netIncome",
              },
            }}
          >
            {personData.netIncome.toLocaleString("de-DE", { style: "currency", currency: "EUR" })} €
          </GridEditRow>
        </>
      )}

      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={personType + ".otherIncome"} sx={summaryStyle.scrollToAnchor} />
        Sonstiges Nettoeinnahmen
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: personType + ".otherIncome",
          },
        }}
      >
        {personData.otherIncome.toLocaleString("de-DE", { style: "currency", currency: "EUR" })} €
      </GridEditRow>

      {formData.basicChoice === "complete" && (
        <>
          <Grid item xs={12} sx={summaryStyle.question}>
            <Box id={personType + ".hasMarriageRelatedDisadvantages"} sx={summaryStyle.scrollToAnchor} />
            Liegen ehebedingte Nachteile vor?
          </Grid>
          <GridEditRow
            item
            xs={12}
            to={{
              pathname: formPath,
              state: {
                section: section,
                field: personType + ".hasMarriageRelatedDisadvantages",
              },
            }}
          >
            {personData.hasMarriageRelatedDisadvantages ? "Ja" : "Nein"}
          </GridEditRow>
        </>
      )}

      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={personType + ".livingExpenses"} sx={summaryStyle.scrollToAnchor} />
        Wohnkosten
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: personType + ".livingExpenses",
          },
        }}
      >
        {personData.livingExpenses.toLocaleString("de-DE", { style: "currency", currency: "EUR" })} €
      </GridEditRow>

      <Grid item xs={12} sx={summaryStyle.question}>
        <Box id={personType + ".otherExpenses"} sx={summaryStyle.scrollToAnchor} />
        Sonstige Ausgaben
      </Grid>
      <GridEditRow
        item
        xs={12}
        to={{
          pathname: formPath,
          state: {
            section: section,
            field: personType + ".otherExpenses",
          },
        }}
      >
        {personData.otherExpenses.toLocaleString("de-DE", { style: "currency", currency: "EUR" })} €
      </GridEditRow>
    </>
  );
};

export default PersonData;
